export const DEFAULT_TEMPLATE_FONT_SIZE = 12;

export const TEMPLATE_FONT_SIZE_OPTIONS = [8, 9, 10, 11, 12, 13, 14, 16, 18, 20, 24];

export function wrapTemplateContent(html, fontSize = DEFAULT_TEMPLATE_FONT_SIZE) {
  const size = TEMPLATE_FONT_SIZE_OPTIONS.includes(Number(fontSize))
    ? Number(fontSize)
    : DEFAULT_TEMPLATE_FONT_SIZE;
  const inner = (html || '').trim();
  return `<div data-template-font-size="${size}" style="font-size: ${size}px">${inner}</div>`;
}

export function parseTemplateContent(storedHtml) {
  const raw = (storedHtml || '').trim();
  if (!raw) {
    return { fontSize: DEFAULT_TEMPLATE_FONT_SIZE, html: '' };
  }

  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(raw, 'text/html');
    const wrapper = doc.body.firstElementChild;
    const sizeAttr = wrapper?.getAttribute('data-template-font-size');
    if (sizeAttr) {
      const parsed = parseInt(sizeAttr, 10);
      const fontSize = TEMPLATE_FONT_SIZE_OPTIONS.includes(parsed) ? parsed : DEFAULT_TEMPLATE_FONT_SIZE;
      return { fontSize, html: wrapper.innerHTML };
    }
  }

  return { fontSize: DEFAULT_TEMPLATE_FONT_SIZE, html: raw };
}
